// /src/renderer/app/rootReducer.ts
import { combineReducers } from '@reduxjs/toolkit';
// import authReducer from '../features/auth/AuthSlice';
import envReducer from '@slices/envSlice';
import testReducer from '@slices/testSlice'
import historyReducer from '@slices/historySlice'

// import modalReducer from '@slices/modalSlice';
import studyReducer from '@features/browser/BrowserPageSlice'
import settingReducer from '@features/analysis/analysisModal/SettingsModal/SettingsModalSlice'
import authReducer from '@features/auth/AuthSlice'
import analysisReducer from '@features/analysis/AnalysisPageSlice'
// import analysisReducer from '@features/dicomAnalysis/analysisList/NavbartopSlice'
// import toolReducer from '@features/dicomAnalysis/analysisTool/NavbarbottomSlice'

// 추가 리듀서가 있으면 여기에 등록합니다.

export const rootReducer = combineReducers({
  auth: authReducer,
  study: studyReducer,
  analysis: analysisReducer,
  history: historyReducer,
  // tools: toolReducer,
  env: envReducer,
  posts: testReducer,
  // modal: modalReducer,
  settings: settingReducer
});


/**
 * action 명명
 * set: 상태를 특정 값으로 설정할 때 (예: setSelectedTool)
 * update: 기존 상태의 일부를 갱신할 때 (예: updateUserProfile)
 * add: 새로운 항목을 추가할 때 (예: addTodo)
 * remove 또는 delete: 항목을 제거할 때 (예: removeItem, deletePost)
 * toggle: Boolean 상태를 반전시킬 때 (예: toggleSidebar)
 * fetch, request: 데이터를 요청할 때 (예: fetchDataRequest)
 * receive: 데이터를 성공적으로 받아왔을 때 (예: receiveData)
 * fail: 실패한 결과를 처리할 때 (예: fetchDataFail)
 * clear 또는 reset: 상태를 초기화하거나 지울 때 (예: clearNotifications, resetForm)
 */

// export  rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
